/**
 * Created by Rodrigo Quesada on 03/03/17.
 */
import {NgModule} from '@angular/core';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {ReleasePageComponent} from './release-page.component';
import {ReleaseAuthorizationScreenComponent} from './steps/authorization/release-authorization-screen.component';
import {SignatureInputModule} from '../../components/forms/controls/signature/signature-input.module';
import {ReleaseSectionService} from './model/release-section.service';

@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        SignatureInputModule
    ],
    declarations: [
        ReleasePageComponent,
        ReleaseAuthorizationScreenComponent
    ],
    providers: [ReleaseSectionService]
})
export class ReleasePageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/release-page.module.ts